import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const HolidayCalendarTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  getModal = () => { }
}) => {
  const { t, i18n } = useTranslation();
  // const isLoading = useSelector((state) => state.holidayCalendar.isLoading);

  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const columns = [
    {
      title: <div className="text-table">{t("holiday.label.date")}</div>,
      dataIndex: "date",
      key: "date",
      width: 150,
      sorter: {
        compare: (a, b) => new Date(a.holidayCalendar?.date) - new Date(b.holidayCalendar?.date),
      },
      render: (_, record) => {
        return <div style={{}}>{formatDate(record?.holidayCalendar?.date)}</div>
      }
    },
    {
      title: <div className="text-table">{t("holiday.label.name_th")}</div>,
      dataIndex: "holidayName",
      key: "holidayName",
      sorter: {
        compare: (a, b) => (a.holidayCalendar?.holidayName || '').localeCompare(b.holidayCalendar?.holidayName || '', "th"),
      },
      render: (_, record) => {
        return record?.holidayCalendar?.holidayName
      }
    },
    {
      title: <div className="text-table">{t("holiday.label.name_en")}</div>,
      dataIndex: "holidayNameEn",
      key: "holidayNameEn",
      sorter: {
        compare: (a, b) => (a.holidayCalendar?.holidayNameEn || "").localeCompare(b.holidayCalendar?.holidayNameEn || "", "en")
      },
      render: (_, record) => {
        return record?.holidayCalendar?.holidayNameEn
      }
    },
    {
      title: <div className="text-table">{t("holiday.label.type")}</div>,
      dataIndex: "holidayType",
      key: "holidayType",
      width: 160,
      sorter: {
        compare: (a, b) => {
          const nameA = i18n.language === "en" ? a.holidayCalendar?.holidayType?.nameEn : a.holidayCalendar?.holidayType?.name;
          const nameB = i18n.language === "en" ? b.holidayCalendar?.holidayType?.nameEn : b.holidayCalendar?.holidayType?.name;

          return (nameA || '').localeCompare(nameB || '');
        }
      },
      render: (_, record) => {
        return i18n.language === "en" ? record?.holidayCalendar?.holidayType?.nameEn : record?.holidayCalendar?.holidayType?.name
      }
    },
    {
      title: <div className="text-table">{t("holiday.label.status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      render: (text, record) => (
        console.log("status ", record?.holidayCalendar?.statusFlag),
        <Switch
          checked={record?.holidayCalendar?.statusFlag === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record?.holidayCalendar?.id)}
          disabled={roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR") ? {
      title: <div className="text-table">{t("holiday.label.action")}</div>,
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|HOLIDAY_CALENDAR") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
                },
              ].filter(Boolean),
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray", cursor: "pointer" }} />
          </Dropdown>
        </Space>
        // <Space size="middle">
        //   <EditOutlined style={{ fontSize: "25px", color: "gray" }} onClick={(e) => {
        //     e.preventDefault();
        //     // onDelete(record);
        //     onEdit(record)

        //   }} />
        // </Space>
      ),
    } : {},

  ];

  return (
    <>

      <TableAntd
        loading={isLoading}
        pagination={false}
        dataSource={dataSource}
        rowKey={(record) => record?.holidayCalendar?.id}
        columns={columns}
        onChange={onChange}
        scroll={{ x: true }}
      />
    </>
  );
};

export default HolidayCalendarTable;
